import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

const plummet = [
  new Dialog(
    "[The Elevator MALFUNCTIONS and plummets to the ground!]",
    require("@/images/Elevator_Shaft.png"),
    require("@/audio/loseitem.mp3")
  ),
];

const useCard = [
  new Dialog(
    "[Used SHIBARI KEY CARD]",
    require("@/images/Shibari_Keycard.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class Elevator extends Scene {
  async init() {
    this.title = "Office Elevator";
    this.image = require("@/images/Elevator_Control_Panel.png");
    this.audio = null;
    this.description = "";
  }

  wrongChoice = async () => {
    await this.dialogRunner(plummet)
    await this.navigate(scenes.EmergencyRoom())
  };

  get options(): any[] {
    return [
      new Choice("Leave", async () => await this.navigate(scenes.ShibariLobby())),
      new Choice("1 - Bumforth and Sons", this.wrongChoice),
      new Choice("2 - John Inc", this.wrongChoice),
      new Choice(
        "3 - Cinema Ticket Stub Tearers Union of Western Australia",
        this.wrongChoice
      ),
      new Choice(
        "4 - Yuh - buh - duh Hur - buh - duh, Attorney at Law",
        this.wrongChoice
      ),
      new Choice(
        "5 - The Number One Best Company in the World",
        this.wrongChoice
      ),
      new Choice("6 - Eel Pie Appreciation Society", this.wrongChoice),
      new Choice(
        "7 - A Reputable Business and Not a Front for Anything, We Swear",
        this.wrongChoice
      ),
      new Choice("8 - Shibari International", async () => {
        if (!this.state.inventory.shibariKeyCard.has) {
          this.description =
            "SONNY YANG: It seems access to the Shibari premises is restricted to staff only. Looks like I’ll need some kind of electronic KEY CARD.";
        } else {
          await this.dialogRunner(useCard)
          await this.navigate(scenes.OfficeInterior())
        }
      }),
      new Choice("9 - Sonforth & Bums", this.wrongChoice),
      new Choice(
        "10 - One Lone Accounting Firm Against the World",
        this.wrongChoice
      ),
    ];
  }
}

export default new Elevator();
